
import type { PropType } from 'vue'
import type { EpbInputHelpSize, EpbInputHelpType } from './epb-input-help.types'
import { defineComponent } from 'vue'
import { ColorEnum } from '../../../enums'
import { UiTooltip } from '../../keen-ui'
import { EpbText } from '../epb-text'

export default defineComponent({
  name: 'EpbInputHelp',
  components: {
    EpbText,
    UiTooltip,
  },
  props: {
    text: {
      type: String,
      default: undefined,
    },
    icon: {
      type: String,
      default: undefined,
    },
    type: {
      type: String as PropType<EpbInputHelpType>,
      default: 'default',
    },
    size: {
      type: String as PropType<EpbInputHelpSize>,
      default: 'md',
    },
    tooltip: {
      type: String,
      default: undefined,
    },
    tooltipPosition: {
      // top, bottom, left, right (all of them can be concatenated with '-start' or '-end')
      type: String,
      default: 'bottom',
    },
  },
  setup() {
    const baseClass = 'epb-input-help'

    return {
      baseClass,
      ColorEnum,
    }
  },
})
